const pwgen = (length = 12) => {
  const chars = '!@#$%^&*()~0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'
  return Array.from(crypto.getRandomValues(new Uint32Array(length)))
    .map(rnd => chars[rnd % chars.length])
    .join('')
}

export const helpersPassword = {
  pwgen,
}
